import { render } from "./BarsChart.vue?vue&type=template&id=3e3d40ee&scoped=true"
import script from "./BarsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BarsChart.vue?vue&type=script&setup=true&lang=js"

import "./BarsChart.vue?vue&type=style&index=0&id=3e3d40ee&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3d40ee"],['__file',"resources/js/components/common/bars-chart/BarsChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e3d40ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e3d40ee', __exports__)) {
    console.log('reload')
    api.reload('3e3d40ee', __exports__)
  }
  
  module.hot.accept("./BarsChart.vue?vue&type=template&id=3e3d40ee&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e3d40ee', render)
  })

}


export default __exports__